import { FilterCombinator, FilterComparator, OrderType } from '@okcargo/query-processor';

export interface FindOptions {
  id: string;
  abortSignal?: AbortSignal;
}

// based in CriteriaPayload in query processor, decoupled from external lib with abortSignal added
export interface SearchOptions {
  criteriaPayload: {
    pageIndex: number;
    pageSize: number;
    filters: FilterOptions[];
    order: OrderOptions[];
    classifierPayload: Classifier;
    /**
     * @deprecated
     */
    classierPayload: Classifier;
  };
  abortSignal?: AbortSignal;
}

// to build the queries, pass only the necessary properties from the application layer, while always maintaining the same structure
export type PartialSearchOptions = Omit<Partial<SearchOptions>, 'criteriaPayload'> & {
  criteriaPayload?: Partial<SearchOptions['criteriaPayload']>;
};

// same as OrderPayload in query processor, decoupled from external lib
export interface OrderOptions {
  field: string;
  type: OrderType;
}

// same as FilterPayload in query processor, decoupled from external lib
export interface FilterOptions {
  field: string;
  value: any; // TODO review: unknown?
  combinator: FilterCombinator;
  comparator: FilterComparator;
  group: FilterGroupPayload;
}

// same as FilterPayload in query processor, decoupled from external lib
export interface FilterGroupPayload {
  combinator: FilterCombinator;
  filterPayload: FilterOptions[];
}

export interface Classifier {
  fields: string[];
}

// same as PageMetadata in query processor, decoupled from external lib
// for the new way of obtaining data about counters in the query
// not in use for now
export interface PageMetadata {
  totalElements: number;
  totalPages: number;
  currentPage: number;
}

// similar function to that of PagedResponse<T> in query processor
export interface SearchResult<T> {
  items: T[];
  totalElements: number;
}

// replicate enums from query processor
export { FilterCombinator, FilterComparator, OrderType };

// default values
export const PAGE_DEFAULT = 0;
export const PAGE_SIZE_DEFAULT = 100;

// field names, from diferent sources

export enum FieldNames {
  FINISHING_AT = 'FINISHING_AT', // FreightFieldNames

  // DESTINATION_DATE = 'DESTINATION_DATE', // DigitalControlDocFieldNames
  // ORIGIN_DATE = 'ORIGIN_DATE,', // DigitalControlDocFieldNames
  EARLIEST_STARTING_AT = 'EARLIEST_STARTING_AT', //  FreightFieldNames, DigitalControlDocFieldNames
  STATUS = 'STATUS', // FreightFieldNames and others
  LATEST_STARTING_AT = 'LATEST_STARTING_AT', // FreightFieldNames, DigitalControlDocFieldNames

  ID = 'ID', // FreightFieldNames and others
  DRIVER_CONTACT_ID = 'DRIVER_CONTACT_ID', // FreightFieldNames
  SHIPPER_FREIGHT_M2M_REFERENCE = 'SHIPPER_FREIGHT_M2M_REFERENCE', // FreightFieldNames

  // TODO review
  RAW_FIRST_STOP = 'RAW_FIRST_STOP', // FreightFieldNames
  RAW_LAST_STOP = 'RAW_LAST_STOP', // FreightFieldNames

  NUMBER_OF_DELIVERY_NOTES = 'NUMBER_OF_DELIVERY_NOTES', // FreightFieldNames
  DELIVERY_NOTE_IN_PAPER = 'DELIVERY_NOTE_IN_PAPER', // FreightFieldNames
  DELIVERY_NOTE_IN_PAPER_SENT_AT = 'DELIVERY_NOTE_IN_PAPER_SENT_AT', // FreightFieldNames

  TRACTOR_PLATE_NUMBER = 'TRACTOR_PLATE_NUMBER', // DigitalControlDocFieldNames
  TRAILER_PLATE_NUMBER = 'TRAILER_PLATE_NUMBER', // DigitalControlDocFieldNames
}
